import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, pos, ...other } = props;
  const Icon = variantIcon[variant];
  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          {Icon && <Icon className={classNames(classes.icon, classes.iconVariant)} />}
          {message}
        </span>
      }
      action={
        [
          // <IconButton
          //   key="close"
          //   aria-label="Close"
          //   color="inherit"
          //   className={classes.close}
          //   onClick={onClose}
          // >
          //   <CloseIcon className={classes.icon} />
          // </IconButton>,
        ]
      }
      pos={pos}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
  pos: PropTypes.string
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing.unit
  }
});

class CustomizedSnackbars extends React.Component {
  state = {
    open: false
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    // Determine duration based on message content
    let duration = 66000; // Default 66 seconds

    // For lockout messages, use much longer duration (5 minutes)
    if (this.props.message && typeof this.props.message === 'string' &&
      this.props.message.includes('ACCOUNT LOCKED FOR 30 MINUTES')) {
      duration = 300000; // 5 minutes (300 seconds)
    }
    // For other important error messages, use longer duration (2 minutes)
    else if (this.props.variant === 'error' && this.props.message &&
      typeof this.props.message === 'string' &&
      (this.props.message.includes('locked') ||
        this.props.message.includes('OTP') ||
        this.props.message.includes('security'))) {
      duration = 120000; // 2 minutes (120 seconds)
    }

    return (
      <div>
        {this.props.opentoast ? (
          <Snackbar
            anchorOrigin={{
              vertical: this.props.pos ? this.props.pos : "top",
              horizontal: "center"
            }}
            open={this.props.opentoast}
            autoHideDuration={duration}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={this.props.variant}
              message={this.props.message}
              pos={this.props.pos}
            />
          </Snackbar>
        ) : null}
      </div>
    );
  }
}

CustomizedSnackbars.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles2)(CustomizedSnackbars);
